export default {
  app: {
    orgCode: "Бүлэг/брэндийн дугаар",
    orgCodePlaceholder: "Бүлэг/брэндийн дугаараа оруулна уу",
    username: "данс",
    usernamePlaceholder: "Дансны дугаараа оруулна уу",
    password: "нууц үг",
    passwordPlaceholder: "Нууц үгээ оруулна уу",
    captcha: "Баталгаажуулах код",
    captchaPlaceholder: "Баталгаажуулах кодыг оруулна уу",
    captchaExpired: "Баталгаажуулах кодыг дахин оруулна уу.",
    login: "Нэвтрэх",
    remember: "Намайг санаарай",
    switchPC: "Арын дэвсгэр рүү шилжих",
    mobileVersion: "Мобайл BI",
    desktopVersion: "Худалдаачны Бэкенд",
    setupPassword: "Нууц үг тохируулах",
    newPassword: "Шинэ нууц үг",
    newPasswordPlaceholder: "Шинэ нууц үг оруулна уу",
    retypePassword: "Шинэ нууц үгээ дахин оруулна уу",
    retypePasswordPlaceholder: "Шинэ нууц үгээ дахин оруулна уу",
    setupPasswordRule: "Нууц үг нь 6-32 тэмдэгтээс бүрдэх бөгөөд хоёр ба түүнээс дээш тооны хослол, үсэг, тэмдэгт агуулсан байх ёстой.",
    setupPasswordRuleRefer: "Нууц үг нь 6-32 тэмдэгтээс бүрдэх бөгөөд хоёр ба түүнээс дээш тооны хослол, үсэг, тэмдэгт агуулсан байх ёстой. Дахин оруулна уу.",
    setupPasswordOk: "Тийм",
    setupPasswordDiffer: "Таны хоёр удаа оруулсан нууц үг таарахгүй байна. Нууц үгээ дахин оруулна уу.",
    err_def: "Нэвтэрч чадсангүй, хуудсыг дахин сэргээгээд дахин оролдоно уу.",
    err_2000: "Баталгаажуулах кодыг буруу оруулсан байна.",
    err_2010: "Нэвтрэх мэдээллийг буруу оруулсан байна.",
    err_4001: "Энэ бүртгэл ямар ч функцийг зөвшөөрөөгүй.",
    err_4011: "Дэлгүүр идэвхгүй болсон тул нэвтрэх боломжгүй.",
    err_4012: "Франчайз хүлээн авагч идэвхгүй болсон тул нэвтэрч чадахгүй байна.",
    err_4013: "Брэнд идэвхгүй болсон тул нэвтрэх боломжгүй байна.",
    err_4014: "Бүлэг идэвхгүй болсон тул нэвтрэх боломжгүй.",
    err_4015: "Энэ бүс идэвхгүй болсон тул нэвтрэх боломжгүй байна.",
    err_4401: "Энэ бүртгэл энэ дэлгүүрт зөвшөөрөгдөөгүй.",
    err_4402: "Энэ бүртгэл нь администраторын эрхгүй бөгөөд баталгаажуулах код авах боломжгүй.",
    err_5001: "Нууц үгийг тохируулж чадсангүй, дахин оролдоно уу.",
  },
  verifyRefund: {
    title: "Буцаах хүсэлт",
    hint: "Баталгаажуулах кодыг өгөхөөс өмнө буцаах мэдээлэл зөв эсэхийг баталгаажуулна уу!",
    verifyCode: "Баталгаажуулах код",
    copy: "хуулбарлах",
    copySucceed: "Амжилттай хуулах",
    copyFailed: "Хуулбарлах алдаа",
    expireTime: "Хугацаа дуусах хугацаа",
    shop: "дэлгүүр",
    soTime: "Захиалгын хугацаа",
    soNo: "POS захиалгын дугаар",
    amount: "Буцаан олголтын хэмжээ",
  },
}